// Business information for Guiri - AI assistant for Spanish bureaucracy
export const BUSINESS_INFO = {
  // Core product information
  name: "Guiri",
  fullName: "Guiri - Your Spain Survival Guide",
  description: "AI-powered assistant helping expats navigate Spanish bureaucracy with confidence. Get personalized help with government letters, forms, and official documents.",
  
  // Digital product details
  applicationCategory: "UtilitiesApplication",
  operatingSystem: ["Web", "iOS", "Android"],
  
  // URLs and contact
  url: "https://guiri.app",
  contactEmail: "hello@guiri.app",
  supportEmail: "support@guiri.app",
  
  // Social media and external profiles
  socialProfiles: {
    twitter: "https://twitter.com/guiriapp",
    facebook: "https://facebook.com/guiriapp",
    instagram: "https://instagram.com/guiriapp"
  },
  
  // App store information (when available)
  appStores: {
    ios: "https://apps.apple.com/app/guiri",
    android: "https://play.google.com/store/apps/details?id=app.guiri"
  },
  
  // Product features and keywords
  features: [
    "AI-powered document analysis",
    "Spanish bureaucracy assistance", 
    "Government letter translation",
    "Personalized expat guidance",
    "NIE and TIE renewal help",
    "Tax document assistance",
    "Healthcare navigation",
    "Banking guidance"
  ],
  
  // Target audience keywords
  targetAudience: [
    "expats in Spain",
    "Spanish immigrants", 
    "digital nomads Spain",
    "foreigners in Spain",
    "Spanish bureaucracy help",
    "NIE assistance",
    "Spanish paperwork help"
  ],
  
  // Pricing information
  pricing: {
    free: {
      name: "Free",
      price: "0",
      currency: "EUR",
      features: ["Daily AskGuiri question limit", "1 free document scan (lifetime)", "Community access"]
    },
    premium: {
      name: "Guiri Pro",
      price: "5.99",
      currency: "EUR",
      billingPeriod: "monthly",
      features: [
        "Higher monthly AskGuiri limits",
        "30 document scans per month (PDF + photo: padrón, NIE/TIE, Hacienda letters, payslips)",
        "Better-grounded models for complex questions",
        "Priority support",
        "Early access to new features"
      ]
    }
  },
  
  // Company information
  company: {
    name: "Guiri",
    foundedYear: "2024",
    location: "Spain",
    type: "Technology Company"
  },
  
  // SEO metadata
  seo: {
    keywords: "Spanish bureaucracy, expat help, NIE renewal, Spanish paperwork, government letters, AI assistant, Spain immigration",
    ogImage: "https://guiri.app/og/og-image.png",
    twitterCard: "summary_large_image"
  }
} as const;

// Helper function to get consistent brand name
export const getBrandName = () => BUSINESS_INFO.name;

// Helper function to get full product description
export const getProductDescription = () => BUSINESS_INFO.description;

// Helper function to get contact email
export const getContactEmail = () => BUSINESS_INFO.contactEmail;

// Helper function to get app store links
export const getAppStoreLinks = () => BUSINESS_INFO.appStores;

// Helper function to get social media profiles
export const getSocialProfiles = () => BUSINESS_INFO.socialProfiles;